<template>
  <div class="exam-calculator">
    <div class="exam-calculator__box-button">
      <button
        class="exam-calculator__btn-open btn btn-primary"
        @click="openCalculator()"
      >
        <svg-loader
          src="/static/images/site/icon-calculator.svg"
          class=""
        />
        Calculadora de exames
      </button>
    </div>

    <CalculatorWrapper
      :is-opened="calculatorOpened"
      @closeCalculator="closeCalculator()"
    />
  </div>
</template>
<script>
import CalculatorWrapper from './CalculatorWrapper.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Calculator',
  components: {
    CalculatorWrapper
  },
  data: () => {
    return {
      calculatorOpened: false
    }
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    openCalculator() {
      this.calculatorOpened = true
      document.body.style.overflow = 'hidden'
      this.submitAnalyticsEvent()
    },
    closeCalculator() {
      this.calculatorOpened = false
      document.body.style.overflow = null
    },
    submitAnalyticsEvent() {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Calculadora - Guia de Exames',
        action: 'Calculadora foi aberta',
        'id-user': this.profile ? this.profile.id : 'Usuário não logado',
        'id-lab': this.profile ? this.profile.id_laboratory : 'Usuário não logado',
        'name-lab': this.profile ? this.profile.laboratoryName : 'Usuário não logado'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .exam-calculator {
    display: flex;
    position: relative;
    z-index: 1000;

    &__box-button {
      width: 27%;
    }

    &__btn-open {
      width: 232px;
      height: 32px;
      font-family: 'Exo 2';
      text-transform: uppercase;
      display: flex;
      align-items: center;
      padding: 0 15px;
      background: #fff;
      color: #7f1a54;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 2px 2px rgba(129, 129, 129, 0.3);
      border-radius: 4px;
      font-size: 12px;
      font-weight: 600;

      &:hover {
        background: #f2f2f2 !important;
      }

      .md-icon {
        margin: 0;
        margin-right: 12px;
        min-width: 15px;
        width: 15px;
      }
    }
  }
</style>
